import { alpha } from '@mui/material';
import styled from 'styled-components';
import { ReadOnlyField } from '../../styled';

export const ProposalCurationBannerContainer = styled(ReadOnlyField)`
  display: flex;
  align-items: center;
  background-color: ${({ color }) => alpha(color, 0.1)};
  color: ${({ color }) => color};
  margin-bottom: 16px;
  border: 1px solid ${({ color }) => color};
  pointer-events: none;
`;
